import React from "react";

//Router
import { Routes, Route, Navigate } from "react-router-dom";

//Auth pages
import Login from "Pages/Auth/Login";
import CreatePassword from "Pages/Auth/ResetPassword";

//Policy page
import PolicyPage from "Pages/PolicyPage";

//Redirect Page
import RedirectPage from "Pages/RedirectPage";

//Delete Account Page
import DeleteAccount from "Pages/DeleteAccountPage";
import DeleteConfirmation from "Pages/DeleteConfirmation";

//Protected pages
import Dashboard from "Pages/Protected/Dashboard";
import Request from "Pages/Protected/Request";
import ChooseKG from "Pages/Protected/ChooseKG";
import CompanyManagement from "Pages/Protected/CompanyManagement";
import UserManagement from "Pages/Protected/UserManagement";
import ContentManagement from "Pages/Protected/ContentManagement";
import StaffManagement from "Pages/Protected/StaffManagement";
import ContactRequestManagement from "Pages/Protected/ContactRequestManagement";
import ProductCatalog from "Pages/Protected/ProductCatalog";
import Settings from "Pages/Protected/Settings";

//Request page children
import CallRequest from "Components/Request/CallRequest";
import CreditRequest from "Components/Request/CreditRequest";
import FailureAnalysisRequest from "Components/Request/FailureAnalysisRequest";
import MaintenanceRequest from "Components/Request/MaintenanceAssessment";
import PurchaseRequest from "Components/Request/PurchaseRequests";
import ConditionMonitoringRequest from "Components/Request/CondtionMonitoringRequest";

//Purchase request Details
import PurchaseRequestDetails from "Pages/Protected/Request/PurchaseRequestDetails";

//failure analysis request details
import FailureAnalysisRequestDetails from "Pages/Protected/Request/FailureAnalysisRequestDetails";

//failure analysis request details children
import FailureDetails from "Components/Request/FailureAnalysisRequest/FailureDetails";
import MachineInformation from "Components/Request/FailureAnalysisRequest/MachineInformation";
import BearingUseInformation from "Components/Request/FailureAnalysisRequest/BearingUseInformation";
import LubricationDetails from "Components/Request/FailureAnalysisRequest/LubricationDetails";

//call request details Page
import CallRequestDetails from "Pages/Protected/Request/CallRequestDetails";

//maintenance assessment details page
import MaintenanceAssessmentDetails from "Pages/Protected/Request/MaintenanceAssessmentRequest";

//credit request details page
import CreditRequestDetails from "Pages/Protected/Request/CreditRequestDetails";

//condition monitoring request details page
import ConditionMonitoringRequestDetails from "Pages/Protected/Request/ConditionMonitoringDetails";

//company management add and edit page
import AddCompany from "Pages/Protected/CompanyManagement/AddCompany";
import EditCompany from "Pages/Protected/CompanyManagement/EditCompany";

//company management view page and children
import ViewCompany from "Pages/Protected/CompanyManagement/ViewCompany";
import CompanyInfo from "Pages/Protected/CompanyManagement/ViewCompany/CompanyInfo";
import ManageUsers from "Pages/Protected/CompanyManagement/ViewCompany/ManageUsers";
import NoOfUsersCompanyManagement from "Pages/Protected/CompanyManagement/ViewCompany/NoOfUsers";
import PurchaseHistoryCompanyManagement from "Pages/Protected/CompanyManagement/ViewCompany/PurchaseHistoryCompanyManagement";
import ServiceHistory from "Pages/Protected/CompanyManagement/ViewCompany/ServiceHistory";
import Subscriptions from "Pages/Protected/CompanyManagement/ViewCompany/Subscriptions";

//content management children
import ProductTrainingPrograms from "Components/ContentManagement/ProductTrainingPrograms";
import IndustryTrainingPrograms from "Components/ContentManagement/IndustryTrainingPrograms";
import BannersAndPromotions from "Components/ContentManagement/BannersAndPromotions";
import FAQs from "Components/ContentManagement/FAQs";
import OfferCodes from "Components/ContentManagement/OfferCode";

//content management add new pages
import AddIndustryTraining from "Pages/Protected/ContentManagement/IndustryTrainingProgramAddPage";
import AddProductTraining from "Pages/Protected/ContentManagement/ProductTrainingProgramsAddPage";
import AddBannersAndPromotions from "Pages/Protected/ContentManagement/BannersAndPromotionsAddPage";
import AddFAQs from "Pages/Protected/ContentManagement/FAQsAddPage";
import AddOfferCode from "Pages/Protected/ContentManagement/OfferCodeAddPage";

//content management edit pages
import EditProductTraining from "Pages/Protected/ContentManagement/EditProductTraining";
import EditIndustryTraining from "Pages/Protected/ContentManagement/EditIndustryTraining";
import EditBannersAndPromotions from "Pages/Protected/ContentManagement/EditBannersAndPromotions";
import EditFAQs from "Pages/Protected/ContentManagement/EditFAQs";
import EditOfferCode from "Pages/Protected/ContentManagement/EditOfferCodes";

//content management view pages
import ViewProductTraining from "Pages/Protected/ContentManagement/ViewProductTraining";
import ViewIndustryTraining from "Pages/Protected/ContentManagement/ViewIndustryTraining";
import ViewBanner from "Pages/Protected/ContentManagement/ViewBanner";
import ViewFAQ from "Pages/Protected/ContentManagement/ViewFAQ";
import ViewOfferCode from "Pages/Protected/ContentManagement/ViewOfferCode";

//Add, Edit staff pages and details
import ViewStaff from "Pages/Protected/StaffManagement/ViewStaff";
import AddStaff from "Pages/Protected/StaffManagement/AddStaff";
import EditStaff from "Pages/Protected/StaffManagement/EditStaff";

//Add, edit, view product catalogs
import AddProductCatalog from "Pages/Protected/ProductCatalog/AddProducts";
import EditProductCatalog from "Pages/Protected/ProductCatalog/EditProduct";
import ViewProductCatalog from "Pages/Protected/ProductCatalog/ViewProduct";

//view,edit user
import ViewUser from "Pages/Protected/UserManagement/ViewUser";
import ProfileDetails from "Pages/Protected/UserManagement/ViewUser/ProfileDetail";
import CreditHistory from "Pages/Protected/UserManagement/ViewUser/CreditHistory";
import PurchaseHistory from "Pages/Protected/UserManagement/ViewUser/PurchaseHistory";
import EditUser from "Pages/Protected/UserManagement/EditUser";

//Protected Routes
import ProtectedRoutes from "./ProtectedRoutes";
import SendReportFar from "Pages/Protected/Request/SendReportFar";
import PreviewReport from "Pages/Protected/Request/PreviewReport";
import BecomeDistributer from "Components/ChooseKG/BecomeDistributer";
import Newsletter from "Components/ChooseKG/Newsletter";
import ContactUs from "Components/ChooseKG/ContactUs";
import QuoteRequest from "Components/ChooseKG/QuoteRequest";
import QuoteRequestDetails from "Pages/Protected/ChooseKG/QuoteRequestDetails";
import Mining from "Pages/Protected/Mining";
import MiningNewsletter from "Components/Mining/Newsletter";
import MiningContactUs from "Components/Mining/ContactUs";
import SpeakBearing from "Components/Mining/SpeakBearing";

function RootRoutes() {
  return (
    <Routes>
      <Route element={<Login />} path="/login" />
      <Route element={<CreatePassword />} path="/resetPassword" />

      <Route element={<PolicyPage />} path="/terms-of-use" />
      <Route element={<PolicyPage />} path="/privacy-policy" />
      <Route element={<PolicyPage />} path="/about-us" />
      
      <Route element={<DeleteAccount />} path="/delete-account" />
      <Route element={<DeleteConfirmation />} path="/auth/delete-user/app" />

      <Route element={<RedirectPage />} path="/redirect" />

      <Route element={<ProtectedRoutes />}>
        <Route element={<Dashboard />} path="/" />

        <Route element={<Request />} path="/request">
          <Route index element={<Navigate to="purchaseRequest" />} />
          <Route element={<CallRequest />} path="callRequest" />
          <Route element={<CreditRequest />} path="creditRequest" />
          <Route
            element={<FailureAnalysisRequest />}
            path="failureAnalysisRequest"
          />
          <Route element={<MaintenanceRequest />} path="maintenanceRequest" />
          <Route element={<PurchaseRequest />} path="purchaseRequest" />
          <Route element={<ConditionMonitoringRequest/>} path="conditionMonitoringRequest"/>
        </Route>

        {/* Choose KG*/}
        <Route element={<ChooseKG />} path="/chooseKg">
          <Route index element={<Navigate to="becomeDistributor" />} />
          <Route element={<BecomeDistributer />} path="becomeDistributor" />          
          <Route element={<Newsletter />} path="newsletter" />   
          <Route element={<ContactUs />} path="contact-us" />    
          <Route element={<QuoteRequest />} path="quote-request" />  
        </Route>

        {/* Mining */}
        <Route element={<Mining />} path="/mining">
          <Route index element={<Navigate to="newsletter" />} />
          <Route element={<MiningNewsletter />} path="newsletter" />
          <Route element={<MiningContactUs />} path="contact-us" />
          <Route element={<SpeakBearing />} path="speak-bearing" />
        </Route>

         <Route
          element={<QuoteRequestDetails />}
          path="/chooseKg/quoteRequestDetails/:id"
        />

        {/* purchase request details route */}
        <Route
          element={<PurchaseRequestDetails />}
          path="/request/purchaseRequestDetails/:id"
        />
        {/* failure analysis request details route */}
        <Route
          element={<FailureAnalysisRequestDetails />}
          path="/request/failureAnalysisRequestDetails/:id"
        >
          <Route index element={<Navigate to="failureDetails" />} />
          <Route element={<FailureDetails />} path="failureDetails" />
          <Route element={<MachineInformation />} path="assetDetails" />
          <Route element={<BearingUseInformation />} path="drives" />
          <Route element={<LubricationDetails />} path="lubricationDetails" />
        </Route>
        <Route
          element={<SendReportFar />}
          path="/request/failureAnalysisRequest/sendReport"
        />
        <Route
          element={<PreviewReport />}
          path="/request/failureAnalysisRequest/previewReport"
        />
        {/* call request details route*/}
        <Route
          element={<CallRequestDetails />}
          path="/request/callRequestDetails/:id"
        />
        {/* maintenance assessment details route*/}
        <Route
          element={<MaintenanceAssessmentDetails />}
          path="/request/maintenanceAssessmentDetails/:id"
        />
        {/* credit request details route*/}
        <Route
          element={<CreditRequestDetails />}
          path="/request/creditRequestDetails/:id"
        />
        {/* {condition monitoring details route} */}
        <Route
          element={<ConditionMonitoringRequestDetails />}
          path="/request/conditionMonitoringRequestDetails/:id"
        />
        <Route element={<CompanyManagement />} path="/companyManagement" />
        {/* add and edit company page */}
        <Route element={<AddCompany />} path="companyManagement/AddCompany" />
        <Route
          element={<EditCompany />}
          path="companyManagement/EditCompany/:id"
        />
        {/* View Company Page and Children */}
        <Route
          element={<ViewCompany />}
          path="companyManagement/viewCompany/:id"
        >
          <Route index element={<Navigate to="companyInfo" />} />
          <Route path="companyInfo" element={<CompanyInfo />} />
          <Route path="manageUsers" element={<ManageUsers />} />
          <Route path="noOfUsers" element={<NoOfUsersCompanyManagement />} />
          <Route
            path="purchaseHistory"
            element={<PurchaseHistoryCompanyManagement />}
          />
          <Route path="serviceHistory" element={<ServiceHistory />} />
          <Route path="subscriptions" element={<Subscriptions />} />
        </Route>

        <Route element={<UserManagement />} path="/userManagement" />
        <Route path="/userManagement" element={<UserManagement />} />
        <Route element={<EditUser />} path="userManagement/editUser/:id" />
        <Route element={<ViewUser />} path="userManagement/viewUser/:id">
          <Route index element={<Navigate to="profileDetails" />} />
          <Route path="profileDetails" element={<ProfileDetails />} />
          <Route path="creditHistory" element={<CreditHistory />} />
          <Route path="purchaseHistory" element={<PurchaseHistory />} />
        </Route>

        <Route element={<ContentManagement />} path="/contentManagement">
          <Route index element={<Navigate to="productTrainingProgram" />} />
          <Route
            element={<ProductTrainingPrograms />}
            path="productTrainingProgram"
          />
          <Route
            element={<IndustryTrainingPrograms />}
            path="industryTrainingPrograms"
          />
          <Route
            element={<BannersAndPromotions />}
            path="bannersAndPromotions"
          />
          <Route element={<FAQs />} path="faqs" />
          <Route element={<OfferCodes />} path="offerCodes" />
        </Route>
        {/* Add Content pages routes */}
        <Route
          element={<AddProductTraining />}
          path="/contentManagement/addProductTraining"
        />
        <Route
          element={<AddIndustryTraining />}
          path="/contentManagement/addIndustryTraining"
        />
        <Route
          element={<AddBannersAndPromotions />}
          path="/contentManagement/addBannersAndPromotions"
        />
        <Route element={<AddFAQs />} path="/contentManagement/addFAQs" />
        <Route
          element={<AddOfferCode />}
          path="/contentManagement/addOfferCode"
        />
        {/* Edit Content page routes */}
        <Route
          element={<EditProductTraining />}
          path="/contentManagement/editProductTraining/:id"
        />
        <Route
          element={<EditIndustryTraining />}
          path="/contentManagement/editIndustryTraining/:id"
        />
        <Route
          element={<EditBannersAndPromotions />}
          path="/contentManagement/editBannersAndPromotions/:id"
        />
        <Route element={<EditFAQs />} path="/contentManagement/editFAQ/:id" />
        <Route
          element={<EditOfferCode />}
          path="/contentManagement/editOfferCode/:id"
        />
        {/* View Content page routes */}
        <Route
          element={<ViewProductTraining />}
          path="/contentManagement/viewProductTraining/:id"
        />
        <Route
          element={<ViewIndustryTraining />}
          path="/contentManagement/viewIndustryTraining/:id"
        />
        <Route
          element={<ViewBanner />}
          path="/contentManagement/viewBannersAndPromotions/:id"
        />
        <Route element={<ViewFAQ />} path="/contentManagement/viewFAQ/:id" />
        <Route
          element={<ViewOfferCode />}
          path="/contentManagement/viewOfferCode/:id"
        />

        {/* staff management */}
        <Route element={<StaffManagement />} path="/staffManagement" />
        <Route
          element={<ContactRequestManagement />}
          path="/contact-management"
        />
        {/* add, edit staff page */}
        <Route element={<ViewStaff />} path="/staffManagement/viewStaff/:id" />
        <Route element={<AddStaff />} path="/staffManagement/addStaff" />
        <Route element={<EditStaff />} path="/staffManagement/editStaff/:id" />
        {/* staff management */}
        <Route element={<StaffManagement />} path="/staffManagement" />
        {/* add, edit staff page */}
        <Route element={<ViewStaff />} path="/staffManagement/viewStaff/:id" />
        <Route element={<AddStaff />} path="/staffManagement/addStaff" />
        <Route element={<EditStaff />} path="/staffManagement/editStaff/:id" />

        {/* staff management */}
        <Route element={<ProductCatalog />} path="/productCatalog" />
        {/* add, edit staff page */}
        <Route
          element={<ViewProductCatalog />}
          path="/productCatalog/viewProductCatalog/:id/:category_id/:filter_id?"
        />
        <Route
          element={<AddProductCatalog />}
          path="/productCatalog/addProductCatalog"
        />
        <Route
          element={<EditProductCatalog />}
          path="/productCatalog/editProductCatalog/:id/:category_id"
        />

        {/* settings */}
        <Route element={<Settings />} path="/settings" />
      </Route>
    </Routes>
  );
}

export default RootRoutes;
